import { Directive, ElementRef, OnInit } from '@angular/core';
import { SidebarService } from '@shared/services/sidebar.service';
import { fromEvent } from 'rxjs';

@Directive({
    selector: '[appSidebarOnScroll]',
    standalone: false
})
export class SidebarOnScrollDirective implements OnInit {
  constructor(
    private readonly _el: ElementRef,
    private readonly _sidebars: SidebarService
  ) {}

  ngOnInit(): void {
    fromEvent(this._el.nativeElement.parentElement, 'scroll').subscribe(() => {
      this._sidebars.scrollSidebar(true);
    });
  }
}
